import { render, staticRenderFns } from "./AgencesOwn.vue?vue&type=template&id=3cb5da3e&"
import script from "./AgencesOwn.vue?vue&type=script&lang=js&"
export * from "./AgencesOwn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports